import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const PropertyOwnersTabSkeleton = () => (
  <div className="space-y-6 mt-4">
    <div className="flex justify-between items-center">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-[32px] w-[280px]" />
        <Skeleton className="h-[24px] w-[380px]" />
      </div>

      <Skeleton className="h-10 w-[190px]" />
    </div>

    <div className="flex flex-col gap-4">
      {[...Array(4)].map((_, i) => (
        <Card
          className="p-6 h-[192px] grid grid-cols-1 md:grid-cols-2 gap-6"
          key={`header-${i}`}
        >
          <div className="space-y-3">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-[24px] w-[150px]" />
              <Skeleton className="h-[16px] w-[200px]" />
            </div>

            <Skeleton className="h-5 w-[180px]" />

            <div className="flex flex-col">
              <Skeleton className="h-5 w-[200px]" />

              <div className="mt-2 flex flex-wrap gap-2">
                <Skeleton className="h-5 w-[80px]" />
                <Skeleton className="h-5 w-[150px]" />
              </div>
            </div>
          </div>

          <div className="flex flex-col justify-between space-y-4">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-5 w-[110px]" />
              <Skeleton className="h-5 w-[130px]" />
              <Skeleton className="h-5 w-[100px]" />
            </div>

            <div className="flex gap-2">
              <Skeleton className="h-[32px] w-[103spx]" />
              <Skeleton className="h-[32px] w-[103spx]" />
            </div>
          </div>
        </Card>
      ))}
    </div>
  </div>
);

export default PropertyOwnersTabSkeleton;
